<template>
    <auth-layout>
        <select-profile @success="onSuccess"/>
    </auth-layout>
</template>

<script>

import AuthLayout from '@/components/entrance/AuthLayout'
import SelectProfile from '@/components/entrance/SelectProfile'

import {mapState} from 'vuex'

export default {
    components: {
        AuthLayout,
        SelectProfile
    },
    computed: {
        ...mapState(['account']),
    },
    methods: {
        onSuccess() {
            const vm = this
            vm.$router.push({name: 'basic-info'})
        }
    },
}
</script>
